import webfontloader from 'webfontloader';

export default function fontLoader(FontFamilies) {
  webfontloader.load({
    google: {
      families: FontFamilies
    }
  })
}
